__turbopack_context__.v({
  "dotFlashing": "V7X_Zq_dotFlashing",
  "dot_flashing": "V7X_Zq_dot_flashing",
  "dots_container": "V7X_Zq_dots_container",
  "flip": "V7X_Zq_flip",
  "loading_container": "V7X_Zq_loading_container",
});
